import { LogoBlue, NewLogo } from "@/components/bnp-icons";
import Image from "next/image";
import React, { useEffect } from "react";
import { Footer, LanguageDropdown } from "@/components/bnp-ui";
import Link from "next/link";
import { useCompatRouter as useRouter } from "@/lib/compat-router/context";
import useAuthToken from "@/hooks/useAuthToken";
import Head from "next/head";
import Script from "next/script";
const AuthWrapper = ({
  children,
  footerText,
  footerBtnText,
  footerLink,
  footerIcon,
}: any) => {
  const router = useRouter();
  const { is_logged_in, isLoading } = useAuthToken();

  useEffect(() => {
    if (is_logged_in) router.push("/user/dashboard");
  }, [router, is_logged_in]);

  return (
    <>
      <Script
        id="organization-schema"
        type="application/ld+json"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Find Nigeria Properties",
            url: "https://www.findnigeriaproperties.com",
            logo: "https://www.findnigeriaproperties.com/logo.png",
          }),
        }}
      />
      <div className="bg-base-white min-h-screen flex flex-col">
        <div className="flex-grow flex justify-center items-center">
          <div className="w-full max-w-[1200px] mx-auto flex flex-col items-center lg:items-start lg:flex-row justify-between gap-8 px-4 lg:px-8 mb-[120px]">
            <div
              className="min-h-[720px] hidden lg:block relative w-full max-w-[554px] bg-no-repeat bg-cover"
              style={{
                backgroundImage: "url('/assets/images/onboarding-photo.png')",
              }}
            >
              {/* <Image
                src={"/assets/images/onboarding-photo.png"}
                alt="building-image"
                className="h-[600px] w-full object-cover"
                width={554}
                height={600}
              /> */}

              <div className="bg-base-white rounded-[32px] absolute left-[5%] bottom-[8%] w-full max-w-[600px] h-[157px] p-8">
                <h1 className="text-main-900 font-bold text-[30px]">
                  Helping you&nbsp;
                  <span className="font-playfair text-bnp-cyan italic">
                    navigate
                  </span>
                  &nbsp;the Nigeria property landscape&nbsp;
                  <span className="font-playfair text-bnp-cyan italic">
                    with ease.
                  </span>
                </h1>
              </div>

              <Image
                src={"/assets/images/auth-pattern.png"}
                alt="auth-pattern"
                className="absolute z-10 right-[-30%] bottom-[15%]"
                width={690}
                height={444}
              />
            </div>

            <div className=" w-full max-w-[500px] z-20">
              <Link
                href={"/"}
                className="flex justify-center lg:hidden items-center text-blue-primary my-8"
              >
                <NewLogo />
                <p className="text-base font-bold">FindNigeriaProperties.com</p>
              </Link>

              <div className="flex justify-center bg-white w-full rounded-3xl p-6">
                {children}
              </div>

              <div className="flex gap-6 items-center justify-center text-sm text-grey-7 mt-6">
                <p>{footerText}</p>
                {footerLink && (
                  <Link
                    href={footerLink}
                    className="flex gap-1 items-center justify-center bg-white rounded-[10px] border border-soft-200 w-[118px] h-[32px] font-medium"
                  >
                    <p>{footerBtnText}</p>
                    {footerIcon}
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default AuthWrapper;
